import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Standard Tailwind class merger — shadcn/ui convention. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
